var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",style:({
    transition: 'height 300ms ease-in-out, opacity 300ms ease-in-out',
    overflow: _vm.open ? 'visible' : 'hidden',
    opacity: _vm.open ? '1' : '0'
  })},[_c('div',_vm._b({ref:"innerContainer"},'div',_vm.innerContainerProps,false),[_vm._t("items")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }